import { config } from "../../config"
import { zip } from "../../helpers/utils"

export const stories = {
  read: ({ id }) => {
    const base = config.apiUrl + `/stories/${id}`,
      opt = {}

    return { url: base, opt }
  },

  reverseSearch: ({ asciiedTitle }) => {
    const base = config.apiUrl + `/stories/reverse-search/${asciiedTitle}`,
      opt = {}

    return { url: base, opt }
  },

  readAll: ({ from = null, limit = null }) => {
    const base = config.apiUrl + `/stories`,
      opt = {}

    const params = zip([from, limit], ["f", "l", "q", "t"])

    let query = params
      .filter((param) => param[0] !== null && param[0] !== "")
      .map((param) => `&${param[1]}=${param[0]}`)
      .join("")

    if (query.length) query = "?" + query.substr(1)

    return { url: base + query, opt }
  },

  create: ({ token, story }) => {
    const url = config.apiUrl + `/stories`,
      opt = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(story),
      }

    return { url, opt }
  },

  update: ({ token, story_id, story }) => {
    const url = config.apiUrl + `/stories/${story_id}`,
      opt = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(story),
      }

    return { url, opt }
  },

  delete: ({ token, story_id }) => {
    const url = config.apiUrl + `/stories/${story_id}`,
      opt = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }

    return { url, opt }
  },
}
